export const ERROR_FALLBACK_CONTAINER =
	'command-palette.ui.modal.modal-content.no-results-container';
